"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElementTitle = exports.findTask = exports.findModule = void 0;
var htmlUtils_1 = require("./htmlUtils");
var findModule = function (program, moduleId) { return (program && moduleId ? program.modules.reduce(function (p, c) { return (c.id === moduleId ? c : p); }, null) : null); };
exports.findModule = findModule;
var findTask = function (program, moduleId, taskId) { return (program && moduleId && taskId
    ? program.modules.reduce(function (p, module) { return (module.id === moduleId
        ? module.tasks.reduce(function (pt, task) { return (task.id === taskId ? task : pt); }, null)
        : p); }, null)
    : null); };
exports.findTask = findTask;
var firstQuestionText = function (questions) { return (questions && questions.length > 0 ? (0, htmlUtils_1.textpart)(questions[0].question) : null); };
var firstHeaderOrText = function (htmlContent, length) {
    var _a;
    if (length === void 0) { length = 50; }
    var doc = new DOMParser().parseFromString(htmlContent, 'text/html');
    var t = ((_a = doc.body.children[0]) === null || _a === void 0 ? void 0 : _a.textContent) || '';
    return t.length > length ? "".concat(t.slice(0, length), "...") : t;
};
var getElementTitle = function (element, defaultValue) {
    if (defaultValue === void 0) { defaultValue = '\u00A0'; }
    return element.title
        || firstHeaderOrText(element.htmlContent)
        || firstQuestionText(element.questions)
        || defaultValue;
};
exports.getElementTitle = getElementTitle;
